import React, { useState, useEffect, ChangeEvent } from 'react';
import { Input, Button, Row, Col, Form, FormGroup } from 'reactstrap';

function CancelationForm(props: any) {
  const { data, setData, isLoading, onAccept, onReject } = props;

  const [hasMotivoRechazo, setHasMotivoRechazo] = useState(false);

  useEffect(() => {
    setHasMotivoRechazo(!!data.motivo_rechazo);
  }, [data.id]);

  const accept = () => {
    if (!onAccept) {
      return;
    }

    onAccept();
  };

  const reject = () => {
    if (!onReject) {
      return;
    }

    onReject();
  };

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { target } = event;

    // Guardamos el nuevo valor
    setData({
      ...data,
      [target.name]: target.value,
    });
  };

  const getFormaPagoString = (formaPago: string) => {
    switch (formaPago) {
      case 'Efectivo':
        return 'Efectivo';
      case 'Bancaria':
        return 'Bancaria CBU';
      case 'Tarjeta':
        return 'Tarjeta de Crédito';
      default:
        return '-';
    }
  };

  return (
    <Form>
      <Row>
        <Col sm={6}>
          <h6 className="heading text-muted mb-4">
            Matriculado Solicitante
          </h6>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Matricula</label>
                <p>{ data.matriculate.matricula || '-' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Delegación</label>
                <p>{ data.matriculate.delegacion || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Nombre</label>
                <p>{ data.matriculate.nombre || '-' }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Apellido</label>
                <p>{ data.matriculate.apellido || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <hr className="my-4" />
          <h6 className="heading text-muted mb-4">
            Forma de Pago
          </h6>
          <Row>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Forma de Pago</label>
                <p>{ getFormaPagoString(data.forma_pago || '-') }</p>
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup>
                <label className='form-control-label'>Tipo Tarjeta</label>
                <p>{ data.tipo_tarjeta || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <FormGroup>
                <label className='form-control-label'>Nro. Tarjeta / CBU</label>
                <p>{ data.numero_tarjeta_cbu || '-' }</p>
              </FormGroup>
            </Col>
          </Row>
          <hr className="my-4" />
          <h6 className="heading text-muted mb-4">
            Rechazo
          </h6>
          <Row>
            <Col sm={12}>
              <FormGroup>
                <label className='form-control-label'>Motivo de rechazo</label>
                {
                  hasMotivoRechazo
                    ?
                      <p>{ data.motivo_rechazo }</p>
                    :
                      <Input
                        id="motivo_rechazo"
                        name="motivo_rechazo"
                        type="textarea"
                        value={data.motivo_rechazo ?? ''}
                        onChange={handleInputChange}
                        disabled={isLoading}
                        required
                      />
                }
              </FormGroup>
            </Col>
          </Row>
        </Col>
      </Row>
      {
        onAccept || onReject
          ? <Row>
              <hr className="my-4" />
              <Col className="text-center">
                <Button color="danger" onClick={ reject } disabled={ isLoading }>Rechazar</Button>
                <Button color="success" onClick={ accept } disabled={ isLoading }>Aceptar</Button>
              </Col>
            </Row>
          : null
      }
    </Form>
  );
}

export default CancelationForm;
